import { getLogger } from '../utils/logging';
import ApiService from './ApiService';

const { log, warn } = getLogger('AccountService', { color: 'orange', enabled: false });

class AccountService {

    constructor() {
    }

    public async updateAccountProvider(accountId, provider) {
        return new Promise(async (resolve, reject) => {
            try {
                let r = await ApiService.post(`/account/${accountId}/provider/${provider.name}`, provider);
                return r?.success ? resolve(r.user) : reject(r.error);
            } catch(e) {
                return reject(e);
            }
        });
    }

    public async disconnectAccountProvider(accountId, provider) {
        return new Promise(async (resolve, reject) => {
            try {
                let r = await ApiService.post(`/account/${accountId}/provider/${provider.name}/disconnect`, provider);
                return r?.success ? resolve(r.user) : reject(r.error);
            } catch(e) {
                return reject(e);
            }
        });
    }
    public async sendInvitation(accountId, email, role) {
        return new Promise(async (resolve, reject) => {
            try {
                const r = await ApiService.post(`/account/${accountId}/users/invite`, {
                    email, role
                });
                return r?.success ? resolve(r) : reject(r.error);
            } catch (error) {
                return reject(error);
            }
        });
    }

    public async removePendingInvitation(accountId, email) {
        return new Promise(async (resolve, reject) => {
            try {
                const r = await ApiService.post(`/account/${accountId}/users/remove-invite`, {
                    email
                });
                return r?.success ? resolve(r) : reject(r.error);
            } catch (e) {
                return reject(e);
            }
        });
    }

    public async updateAccount(accountId, account) {
        return new Promise(async (resolve, reject) => {
            try {
                const r = await ApiService.post(`/account/${accountId}`, account);
                return r?.success ? resolve(r.account) : reject(r.error);
            } catch (e) {
                return reject(e);
            }
        });
    }

}

export default new AccountService();